import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import BattingStats from './BattingStats';
import BowlingStats from './BowlingStats';
import './YearSection.css';

const YearSection = ({ year, statsData }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeTab, setActiveTab] = useState('batting');

  const battingPlayers = statsData.batting || [];
  const bowlingPlayers = statsData.bowling || [];

  return (
    <div className="year-section">
      <div 
        className="year-header"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="year-header-content">
          {isExpanded ? <FiChevronUp /> : <FiChevronDown />}
          <h4 className="year-title">Year {year}</h4>
          <span className="year-badge">{battingPlayers.length + bowlingPlayers.length} Players</span>
        </div>
      </div>

      {isExpanded && (
        <div className="year-body">
          <div className="tabs">
            <button 
              className={`tab ${activeTab === 'batting' ? 'active' : ''}`}
              onClick={() => setActiveTab('batting')}
            >
              🏏 Batting ({battingPlayers.length})
            </button>
            <button 
              className={`tab ${activeTab === 'bowling' ? 'active' : ''}`}
              onClick={() => setActiveTab('bowling')}
            >
              🎾 Bowling ({bowlingPlayers.length})
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 'batting' && (
              <BattingStats players={battingPlayers} />
            )}
            {activeTab === 'bowling' && (
              <BowlingStats players={bowlingPlayers} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default YearSection;
